export interface WizardStep {
  readonly label: string;
  readonly componentKeys: readonly string[];
  readonly colSizes?: readonly number[];
}

export const WORKSPACE_PANEL_WIZARD_STEPS: readonly WizardStep[] = [
  { label: 'Trajectory', componentKeys: ['trajectoryGrid', 'trajectoryPlot'] },
  { label: 'UDT', componentKeys: ['undisturbedTemperature', 'udtPlot'] },
  { label: 'Formations', componentKeys: ['formationsCatalog', 'formationTops'], colSizes: [2, 1] },
  { label: 'Fluids', componentKeys: ['fluids'] },
  { label: 'Well Configuration', componentKeys: ['wellConfiguration', 'annulusContents'], colSizes: [2, 1] },
  { label: 'Cementing & Packers', componentKeys: ['cementSelector', 'packers'] },
  { label: 'Operations', componentKeys: ['thermalOperations', 'perforations'], colSizes: [2, 1] },
  { label: 'Temperature', componentKeys: ['thermalTemperatureResults'] },
  { label: 'Pressure', componentKeys: ['thermalPressureResults'] },
  { label: 'Annular Results', componentKeys: ['detailedAnnularResults'] },
  { label: 'APB', componentKeys: ['apbInputs', 'apbResults'] },
  { label: 'Pore & Frac', componentKeys: ['porePressure', 'fracPressure', 'ppfgPlot'], colSizes: [1, 1, 1] },
  { label: 'Pre-Install Loads', componentKeys: ['preInstallLoads'] },
  { label: 'Post-Install Loads', componentKeys: ['postInstallLoads'] },
  { label: 'Design Limits Plot', componentKeys: ['designLimitsPlot'] },
  { label: 'Safety Factors', componentKeys: ['singleLoadSafetyFactors'] },
  { label: 'Connection SF', componentKeys: ['singleConnectionLoadSafetyFactors'] },
  { label: 'Results', componentKeys: ['singleLoadBurst', 'singleLoadCollapse', 'singleLoadAxial'], colSizes: [1, 1, 1] },
  { label: 'Packer', componentKeys: ['packerOperatingEnvelope', 'packerTableResults'], colSizes: [1, 2] },
  { label: 'Lift-Off', componentKeys: ['liftoffResults', 'wellhead'], colSizes: [2, 1] }
];
